import React, {useState} from 'react';
import './settinfAccess.scss';
import {RxCross1} from 'react-icons/rx';
import SearchDropdown from '../../../../template/SearchDropdown/SearchDropdow';
import SearchDropdownBtn from '../../../../template/SearchDropdown/SearchDropdownBtn';

const SettingAccess = ({data, roles, members, addChangeToStore}) => {
  const [arrRoles, setArrRoles] = useState(data?.additionalMasters ? data?.additionalMasters : []);
  const [arrUsers, setArrUsers] = useState(data?.additionalRoles ? data?.additionalRoles : []);
  const [showBtnRole, setShowBtnRole] = useState(true);
  const [inputValueRole, setInputValueRole] = useState('');
  const [showBtnUser, setShowBtnUser] = useState(true);
  const [inputValueUser, setInputValueUser] = useState('');

  const addRole = (obj) => {
    console.log('obj', obj);
    const roleExists = arrRoles.some((role) => role.id === obj.id);
    if (!roleExists) {
      setArrRoles((prevRoles) => [...prevRoles, obj]);
      addChangeToStore({key: 'additionalMasters', value: [...arrRoles, obj]});
    }
    setInputValueRole('');
  };

  const deleteRole = (index) => {
    const updatedRoles = arrRoles.filter((role, idx) => idx !== index);
    setArrRoles(updatedRoles);
    addChangeToStore({key: 'additionalMasters', value: updatedRoles});
  };

  const addUser = (obj) => {
    const userExists = arrUsers.some((user) => user.id === obj.id);
    if (!userExists) {
      setArrUsers((prevUsers) => [...prevUsers, obj]);
      addChangeToStore({key: 'additionalRoles', value: [...arrUsers, obj]});
    }
    setInputValueUser('');
  };

  const deleteUser = (index) => {
    const updatedUsers = arrUsers.filter((user, idx) => idx !== index);
    setArrUsers(updatedUsers);
    addChangeToStore({key: 'additionalRoles', value: updatedUsers});
  };

  return (
    <div className="setting_component_wrap access_component_wrap">
      <h3>Access</h3>
      <div className="access_component_item_access">
        <h4 className="access_component_item_access_title">Administrators</h4>
        <p className="access_component_item_access_subtitle">
          Any role with Administrator permission is considered as a bot master
        </p>
        <div className="access_component_arr_user_wrap">
          {data?.adminRoles?.map((item, idx) => (
            <div key={idx} className="access_component_user_one">
              {item?.hex && (
                <div
                  className="access_component_user_one_color"
                  style={{background: `${item?.hex}`}}></div>
              )}
              {item?.img && <img src={`/img/user/${item?.img}.svg`} alt="" />}
              <p>{item.name}</p>
              {/* <span 
                                    className='access_component_user_one_delete-icon' 
                                    onClick={() => deleteAdmin(idx)}
                                >
                                    <RxCross1/>
                                </span> */}
            </div>
          ))}
          {/* <input type="text" value={inputValue} onChange={(e) => {setInputValue(e.target.value)}} onKeyPress={handleKeyPressAdmin}  /> */}
        </div>
      </div>
      <div className="access_component_item_access">
        <h4 className="access_component_item_access_title">Additional Bot Master Roles</h4>
        <p className="access_component_item_access_subtitle">
          Roles that will be also considered as bot master, even if they do not have the
          Administrator permission
        </p>
        <div className="access_component_arr_user_wrap">
          {arrRoles.map((item, idx) => (
            <div key={idx} className="access_component_user_one">
              {item?.hex && (
                <div
                  className="access_component_user_one_color"
                  style={{background: `${item?.hex}`}}></div>
              )}
              {item?.img && <img src={`/img/user/${item?.img}.svg`} alt="" />}
              <p>{item.name}</p>
              <span
                className="access_component_user_one_delete-icon"
                onClick={() => deleteRole(idx)}>
                <RxCross1 />
              </span>
            </div>
          ))}
          {showBtnRole ? (
            <SearchDropdownBtn setShowBtn={setShowBtnRole} />
          ) : (
            <SearchDropdown
              data={roles}
              value={inputValueRole}
              setInputValue={setInputValueRole}
              setShowBtn={setShowBtnRole}
              handleSelectItem={addRole}
            />
          )}
        </div>
      </div>
      <div className="access_component_item_access">
        <h4 className="access_component_item_access_title">Additional Bot Master Users</h4>
        <p className="access_component_item_access_subtitle">
          Users that will be also considered as bot master, even if they do not have any roles above
        </p>
        <div className="access_component_arr_user_wrap">
          {arrUsers.map((item, idx) => (
            <div key={idx} className="access_component_user_one">
              {item?.color && <div style={{background: `${item?.color}`}}></div>}
              {item?.img && <img src={`/img/user/${item?.img}.svg`} alt="" />}
              <p>{item.name}</p>
              <span
                className="access_component_user_one_delete-icon"
                onClick={() => deleteUser(idx)}>
                <RxCross1 />
              </span>
            </div>
          ))}
          {showBtnUser ? (
            <SearchDropdownBtn setShowBtn={setShowBtnUser} />
          ) : (
            <SearchDropdown
              data={members}
              value={inputValueUser}
              setInputValue={setInputValueUser}
              setShowBtn={setShowBtnUser}
              handleSelectItem={addUser}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SettingAccess;
